// libs
import React from 'react';

import { ChevronDown } from '@lyearn/icons';
import { cn } from '@lyearn/style';
// components
import { Button, Typography } from '@lyearn/ui';

// styles
import { buttonStyles } from '../style';
import { ActionButtonProps } from '.';

const LABEL_CLASSES = {
  label: 'flex truncate',
};

function renderLabel(label: string | React.ReactNode, isSelected: boolean) {
  return (
    <Typography
      as="span"
      className="flex items-center truncate"
      color="text-text-primary"
      variant={isSelected ? 'label-02' : 'body-short-02'}>
      {label}
    </Typography>
  );
}

const ActionButtonDesktop = React.forwardRef(
  (
    {
      children,
      isSelected = false,
      isOpen,
      onClick,
      endIcon,
      startIcon,
      id,
      className,
    }: ActionButtonProps,
    ref: React.Ref<HTMLButtonElement> | undefined,
  ) => {
    return (
      <Button
        ref={ref}
        appearance="secondary"
        className={cn(
          'flex-shrink-0 overflow-hidden truncate bg-s-info-light',
          buttonStyles,
          {
            open: isOpen,
            'border-text-primary': isSelected,
            selected: isSelected || isOpen,
          },
          className,
        )}
        classes={LABEL_CLASSES}
        data-testid={id}
        endIcon={
          endIcon || <ChevronDown className="arrow-icon transition duration-300 ease-in-out" />
        }
        size="small"
        startIcon={startIcon}
        variant="filled"
        onClick={onClick}>
        {renderLabel(children, isOpen || isSelected)}
      </Button>
    );
  },
);

export default ActionButtonDesktop;
